export default __webpack_public_path__ + "static/media/ScratchJr.2dd2f3f3.webp";